export default "<span>{{credit / 100 | number: '':'de-DE' }} {{currency}}</span>\n";